// Registration Model
cv.Registration = Backbone.RESTModel.extend({
  defaults : {
    'first_name' : '',
    'last_name' : ''
  },

  saveMap : {
    'first_name' : 'first_name',
    'last_name' : 'last_name'
  },

  urlRoot: function(){
    return cv.api_path + '/registrations';
  },

  initialize: function(){
    console.log('Registration model initialized.');
  }
});
Cocktail.mixin(cv.Registration, cv.mixins.SyncModel);

// Registrations Collection
cv.Registrations = Backbone.Collection.extend({
  initialize: function(){
    console.log('Registration collection initialized.');
  },

  url: function() {
    return cv.api_path + "/registrations?" + $.param(this.params);
  },

  model: cv.Registration
});
Cocktail.mixin(cv.Registrations, cv.mixins.PaginateModel);
